import {EquityCollateral, UnlodgedCollateral} from "../../../../types/PortfolioMarginResult";

export interface PortfolioCollateral {
    totalCollateral: number;
    collateralUsed: number;
    collateralUtilisation: number;
    specificCover: Array<EquityCollateral>;
    generalCover: Array<EquityCollateral>;
    unlodgedCollateral: Array<UnlodgedCollateral>;
    pending: Array<CollateralMovement>;
}

export interface CollateralMovement {
    code: string;
    quantity: number;
    type: CollateralMovementType;
    price: number;
    haircut: number;
}

export enum CollateralMovementType {
    GENERAL = "GENERAL",
    SPECIFIC = "SPECIFIC",
    UNLODGE = "UNLODGE"
}

export interface LodgeCollateralRequest {
    code: string;
    quantity: number;
    specific: boolean;
}

export interface UnlodgeCollateralRequest {
    code: string;
    quantity: number;
}
